import React from "react";
import { Item, type HomeItemData } from "./item";

export function ItemList({ items }: { items: HomeItemData[] }) {
  return (
    <div className="home-itemlist" aria-label="Pages">
      <div className="home-itemlist-viewport">
        <div className="home-itemlist-track">
          {items.map((it) => (
            <div className="home-itemlist-cell" key={`${it.href}-${it.title}`}>
              <Item {...it} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ItemList;
